module.exports = __webpack_public_path__ + "static/media/thumbnail.5a8bf123.jpg";